import React from 'react';
import { Box, Card, Typography, Stack } from '@mui/joy';
import { KPI, Pie, useDates } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { t } = useTranslation();

    const date = new Date();
    const formattedDateToday = date.toISOString().split('T')[0];

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const formattedDateYesterday = yesterday.toISOString().split('T')[0];

    // const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    // const formattedDateStartOfMonth = `${startOfMonth.getFullYear()}/${String(startOfMonth.getMonth() + 1).padStart(2, '0')}/${String(startOfMonth.getDate()).padStart(2, '0')}`;


    return (
        <Box className="mtska-kpi-set" sx={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gridTemplateRows:'repeat(1, 1fr)'}}>

            <KPI
                title="Campagne assegnate"
                icon="faBullhorn"
                dataProviderName={'statisticsviews/item/count/campaigns/campaign'}
                
            />

            <Box className="mtska-chart mtksa-chart-pie" sx={{ gridRow:'span 2' }}>
                <Pie
                    title={t("Lead assegnate per tipo")}
                    dataProviderName={"statisticsviews/leadspertype/aggregated/views_campaigns_lead/_related_audienceLead_type"}
                    //filters={filterModel}
                    showTotal={true}
                    monochrome={{ enabled: true }}
                    handleFilterChange={() => { }}
                />
            </Box>

            <Box className="mtska-chart mtksa-chart-pie mtksa-chart-pie-highlighted" sx={{ gridRow:'span 2' }}>
                <Pie
                    title={t("Lead per ultimo tipo di esito")}
                    dataProviderName={"statisticsviews/leadsperoutcometype/aggregated/views_campaigns_lead/_related_lastActivity_outcome_processStatus"}
                    //filters={filterModel}
                    showTotal={false}
                    labelToColorMap={{
                        'ko': '#ef4444',
                        'in lavorazione': '#f59e0b',
                        'ok': '#10b981'
                    }}
                    handleFilterChange={() => { }}
                />
            </Box>

            <Box className="mtska-chart mtksa-chart-pie" sx={{ gridRow:'span 2' }}>
                <Pie
                    title={t("Lead per ultimo esito")}
                    dataProviderName={"statisticsviews/leadsperoutcome/aggregated/views_campaigns_lead/_related_lastActivity_outcome_name"}
                    //filters={filterModel}
                    showTotal={false}
                    monochrome={{ enabled: true }}
                    handleFilterChange={() => { }}
                />
            </Box>

            <KPI
                title="Esiti registrati oggi"
                icon="faHandshake"
                dataProviderName={'statistics/item/count/campaigns/campaignactivity'}
                filters={{
                    'items': [{
                        'field': 'created_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateToday
                    }]
                }}
            />

            {/* <Card variant="outlined" sx={{ p: 2 }}>
                <Typography level="title-sm" fontWeight="bold" sx={{ mb: 1 }}>
                    Campagne assegnate
                </Typography>
                <Typography level="h2" sx={{ mb: 0.5 }}>3</Typography>
                <Typography level="body-xs" color="success" sx={{ mb: 2 }}>
                    8% nuovi lead
                </Typography>

                <Box sx={{ position: 'relative', height: 60 }}>
                    <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: 0 }}>
                        <Box sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: '1px',
                            bgcolor: 'neutral.300'
                        }} />

                        <Box sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 8,
                            right: 8,
                            top: 0
                        }}>
                            <Box
                                component="svg"
                                viewBox="0 0 100 40"
                                preserveAspectRatio="none"
                                sx={{
                                    width: '100%',
                                    height: '100%'
                                }}
                            >
                                <polyline
                                    fill="none"
                                    stroke="#1976d2"
                                    strokeWidth="1.5"
                                    points={campaignData.map((value, index) => {
                                        const x = (index / (campaignData.length - 1)) * 100;
                                        const y = 40 - (value / maxCampaign) * 35;
                                        return `${x},${y}`;
                                    }).join(' ')}
                                />

                                {campaignData.map((value, index) => {
                                    const x = (index / (campaignData.length - 1)) * 100;
                                    const y = 40 - (value / maxCampaign) * 35;
                                    return (
                                        <circle
                                            key={index}
                                            cx={x}
                                            cy={y}
                                            r="1.2"
                                            fill="#1976d2"
                                            stroke="#fff"
                                            strokeWidth="0.5"
                                        />
                                    );
                                })}
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mt: 1,
                    px: 0.5
                }}>
                    {months.map((month) => (
                        <Typography key={month} level="body-xs" sx={{
                            fontSize: '0.65rem',
                            transform: 'scale(0.9)',
                            transformOrigin: 'center'
                        }}>
                            {month}
                        </Typography>
                    ))}
                </Box>
            </Card>

            <Card variant="outlined" sx={{ p: 2 }}>
                <Typography level="title-sm" fontWeight="bold" sx={{ mb: 1 }}>Lead da lavorare</Typography>
                <Typography level="h2" sx={{ mb: 0.5 }}>58</Typography>
                <Typography level="body-xs" color="success" sx={{ mb: 2 }}>12% vs settimana scorsa</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box>
                        <Typography level="h4">12</Typography>
                        <Typography level="body-xs">Lead gestite oggi</Typography>
                    </Box>
                    <Typography level="body-xs" color="neutral">3min 45s</Typography>
                </Box>
            </Card>
            <Card variant="outlined" sx={{ p: 2 }}>
                <Typography level="title-sm" fontWeight="bold" sx={{ mb: 1 }}>Esiti contatto mensili</Typography>
                <Stack spacing={1} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 8, height: 8, bgcolor: 'error.500', borderRadius: '2px' }} />
                        <Typography level="body-xs">Non interessato</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 8, height: 8, bgcolor: 'warning.500', borderRadius: '2px' }} />
                        <Typography level="body-xs">Riconfattare</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 8, height: 8, bgcolor: 'success.500', borderRadius: '2px' }} />
                        <Typography level="body-xs">Lead valida</Typography>
                    </Box>
                </Stack>
                <Box sx={{ display: 'flex', alignItems: 'end', gap: 0.5, height: 30 }}>
                    {months.map((m, i) => (
                        <Box key={m} sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box sx={{ width: '80%', height: `${(outcomeData[i] / maxOutcome) * 25}px`, bgcolor: 'primary.500', borderRadius: '4px 4px 0 0', minHeight: 2 }} />
                        </Box>
                    ))}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                    {months.map(m => (
                        <Typography key={m} level="body-xs" sx={{ fontSize: '0.7rem' }}>{m}</Typography>
                    ))}
                </Box>
            </Card> */}
        </Box>
    );
};

export default KPISet;
